import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Spinner, useBreakpointValue, useDisclosure, useToast} from "@chakra-ui/react";
import PDFPage from "./PDFPage";
import {io} from "socket.io-client";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {SERVER_IP, SERVER_IP_SOCKET} from "../../utils/constants";
import {getSessionToken, getSessionTokenVideo, getVideoFileMetadata} from "../../utils/pdf-page-helpers";
import {useAuth} from "../../redux/AuthProvider";
import {
    setHighlightsInDocument,
    setMessagesInDocument,
    setMessagesInDocumentGeneration,
    setMessagesInVideo, setOneVideo, setVideos
} from "../../redux/reducers";
import {MySpinnerLarge} from "../../components/Reuseable/MySpinner";
import ScanModal1 from "../../components/Modals/Scans/ScanModal1";
import PricingScreen from "../../components/Modals/Payments/PricingScreen";
import PDFPageVideo from "./PDFPageVideo";
import {useServerIP} from "../../redux/ServerIPContext";
import {v4 as uuidv4} from "uuid";

export default function WrapperComponentVideo ()  {
    const auth = useAuth();
    const toast = useToast();
    const [socket, setSocket] = useState(null);
    const { id } = useParams();
    const [sessionToken, setSessionToken] = useState("")
    const [currentDocument, setCurrentDocument] = useState(null);
    const { serverIPs, setServerIPs, isDev } = useServerIP();

    const documents = useSelector(state => state.documents.savedVideos)
    // const documents = auth.isLoggedIn ? savedDocuments : auth.playgroundDocuments;

    const [forceRender, setForceRender] = useState(0);
    const [socketID, setSocketID] = useState("");
    const { isTypingVideo, setIsTypingVideo } = useAuth();
    const {isThinkingVideo, setIsThinkingVideo} = useAuth();
    const dispatch = useDispatch();
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();
    const breakpoint = useBreakpointValue({ base: 'base', sm: 'sm', md: 'md', lg: 'lg', xl: 'xl' });
    const isMobile = breakpoint === 'base';
    const navigate = useNavigate();

    // Visual mode (Gemini) state
    const [isVisualMode, setIsVisualMode] = useState(false);
    const [geminiSessionToken, setGeminiSessionToken] = useState("");
    const [geminiPollingKey, setGeminiPollingKey] = useState("");
    const [geminiFileResource, setGeminiFileResource] = useState("");
    const [isGeminiInitializing, setIsGeminiInitializing] = useState(false);

    useEffect( () => {
        console.log("In UseEffect WrapperComponent with id:", id);

        const randomID = uuidv4();

        let userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"

        if (userID === "11111111-1111-1111-1111-111111111111") {
            // append the randomID to the userID
            userID = userID + randomID;
        }
        console.log("USERID guest with random ID", userID)

        const newSocket = io(serverIPs.SERVER_IP_SOCKET, {
            query: { user_id: userID }
        });

        // const newSocket = io(serverIPs.SERVER_IP_SOCKET);
        setSocket(newSocket);
        console.log("Socket:", socket)
        newSocket.on('connected', function(data) {
            console.log("Connected:", data);
            setSocketID("user_" + userID);
        });
        return () => {
            console.log("Socket disconnecting", newSocket)
            newSocket.disconnect();
        }
    }, [id])

    useEffect(() => {
        console.log("In UseEffect WrapperComponent with socket:", socket);
        if (documents.length > 0) {
            console.log("Documents length > 0")
            setCurrentDocument(documents.find((document) => document.id === id));
            setForceRender(prevForceRender => prevForceRender + 1);
        }
    }, [documents.length, id]);

    useEffect(() => {
        console.log("In UseEffect WrapperComponent with currentDocument:", currentDocument);
        if (currentDocument) {
            console.log("CurrentDocument is not null")
            const fetchSessionToken = async () => {
                const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
                console.log("USERID", userID)
                const response = await getSessionTokenVideo(id, userID, serverIPs.SERVER_IP_VIDEO);
                if (response === null) {
                    navigate(`/video2/${id}`);
                }
                
                const videoMetadataResponse = await getVideoFileMetadata(id, userID, serverIPs.SERVER_IP_VIDEO);
                if (response) {
                    console.log("RESPONSE FROM START SESSION", response);
                    // if (response.doc_metadata.highlights) {
                    //     dispatch(setHighlightsInDocument({documentID: currentDocument.id,
                    //         newHighlights: response.doc_metadata.highlights.slice().reverse()}));
                    // }
                    if (response.doc_metadata === undefined) {
                        dispatch(setMessagesInVideo({documentID: currentDocument.id, newMessages: []}));
                    }
                    else if (response.doc_metadata.messages) {
                        dispatch(setMessagesInVideo({documentID: currentDocument.id, newMessages: response.doc_metadata.messages}));
                        // dispatch(setMessagesInDocumentGeneration({documentID: currentDocument.id, newMessages: []}));
                    }

                    if (videoMetadataResponse) {
                        dispatch(setOneVideo({
                            "id" : videoMetadataResponse.file_id,
                            "name" : videoMetadataResponse.filename,
                            "url" : videoMetadataResponse.video_presigned_url,
                            "thumbnail_url" : "",
                            "highlights" : [],
                            "messages" : response.doc_metadata.messages ? response.doc_metadata.messages : [],
                        }))
                    }
                    setSessionToken(response.sessionToken);
                }
            };
            fetchSessionToken().then(r => {});
        }
    }, [currentDocument]);

    // Poll for Gemini video processing status
    const pollGeminiProgress = async (pollingKey) => {
        const maxAttempts = 120; // 10 minutes with 5-second intervals
        let attempts = 0;

        const poll = async () => {
            try {
                console.log("Polling Gemini progress with key:", pollingKey);
                const response = await axios.post(serverIPs.SERVER_IP + "/general_progress", {
                    key: pollingKey
                });

                console.log("Gemini progress response:", response.data);

                // Check if we got the file resource location
                if (response.data.message && response.data.message.startsWith("files/")) {
                    console.log("Gemini video processing complete! File resource:", response.data.message);

                    toast({
                        title: "Visual mode ready!",
                        description: "Just chat again and now the AI will know both the visual input & transcript.",
                        status: "info",
                        duration: 9500,
                        isClosable: true,
                        position: "top",
                    });
                    
                    setGeminiFileResource(response.data.message);
                    setIsGeminiInitializing(false);
                    return;
                }

                // Continue polling if not ready yet
                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(poll, 5000); // Poll every 5 seconds
                } else {
                    console.error("Gemini processing timeout");
                    setIsGeminiInitializing(false);
                    toast({
                        title: "Visual mode processing timeout",
                        description: "Video processing is taking longer than expected. Please try again.",
                        status: "warning",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                console.error("Error polling Gemini progress:", error);
                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(poll, 5000);
                } else {
                    setIsGeminiInitializing(false);
                }
            }
        };

        poll();
    };

    // Initialize Gemini session when visual mode is toggled on
    const initializeGeminiSession = async () => {
        if (geminiFileResource) {
            // Already initialized
            return;
        }

        setIsGeminiInitializing(true);
        const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111";
        console.log("Initializing Gemini session for visual mode, userID:", userID);

        try {
            // Start Gemini video session
            const geminiResponse = await axios.post(serverIPs.SERVER_IP_VIDEO + '/videos/start_video_session_gemini', {
                file_id: id,
                user_id: userID
            });

            const geminiData = geminiResponse.data;
            console.log("Gemini session response:", geminiData);

            if (geminiData.message.polling_key) {
                setGeminiPollingKey(geminiData.message.polling_key);
                console.log("Got Gemini polling key:", geminiData.message.polling_key);

                // Store the Gemini session token
                if (geminiData.message.session_token) {
                    setGeminiSessionToken(geminiData.message.session_token);
                    console.log("Got Gemini session token:", geminiData.message.session_token);
                }

                // Start polling for Gemini processing status
                pollGeminiProgress(geminiData.message.polling_key);
            }
        } catch (error) {
            console.error("Error initializing Gemini session:", error);
            setIsGeminiInitializing(false);
            setIsVisualMode(false);
            toast({
                title: "Error enabling visual mode",
                description: "Please try again later",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };

    // Handle visual mode toggle
    const handleVisualModeToggle = (enabled) => {
        setIsVisualMode(enabled);
        if (enabled && !geminiFileResource) {
            toast({
                title: "Initializing visual mode...",
                description: "We'll notify here again when it's ready. You can still chat normally in the meantime.",
                status: "info",
                duration: 9500,
                isClosable: true,
                position: "top",
            });
            initializeGeminiSession();
        }
    };

    return (
        sessionToken === "" ?
            <div style={{justifyContent:'center', alignItems:'center', display:'flex', height:'100%', width:'100%', paddingTop:"5rem"}}>
                <MySpinnerLarge/>
            </div>
            :
            <div>
                <PDFPageVideo document={documents.find((document) => document.id === id)} isMobile={isMobile}
                         key={forceRender}
                         documents={documents}
                         id={id}
                         isLoggedIn={auth.isLoggedIn}
                         sessionToken={sessionToken}
                         socketID={socketID}
                         socket={socket}
                         isTyping={isTypingVideo} setIsTyping={setIsTypingVideo}
                         isThinking={isThinkingVideo} setIsThinking={setIsThinkingVideo}
                         toast={toast} serverIP={serverIPs.SERVER_IP_VIDEO}
                         isVisualMode={isVisualMode}
                         onVisualModeToggle={handleVisualModeToggle}
                         isGeminiInitializing={isGeminiInitializing}
                         geminiSessionToken={geminiSessionToken}
                         geminiPollingKey={geminiPollingKey}
                         geminiFileResource={geminiFileResource}/>
                <PricingScreen isOpenPricingScreen={isOpenPricingScreen}
                               onClosePricingScreen={onClosePricingScreen}
                               onOpenPricingScreen={onOpenPricingScreen}/>
            </div>
    )
}







